export const TABS = {
  all: 'ALL',
  popular: 'Popular',
}
